import { apiSlice } from "../../app/api/apiSlice";

export const usersApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getPipeline: builder.mutation({
			query: (credentials) => ({
				url: `/api/v1/pipeline/org/${credentials?.orgName}`,
				method: "GET",
			}),
		}),
	}),
});

export const { useGetPipelineMutation } = usersApiSlice;